import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotActivity = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Activity_svg__a)">
            <path
                fill={spotColor}
                d="M32.562 36.385c2.014-2.938 1.484-7.56.954-13.088-.53-5.53-1.06-11.966-4.4-14.263-3.366-2.298-9.515-.455-14.497 2.484-4.983 2.964-8.773 6.998-8.614 10.71.159 3.713 4.24 7.052 7.448 10.284 3.207 3.232 5.565 6.303 9.01 7.211 3.473.882 8.058-.373 10.099-3.338Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M36.665 20H30l-5 15-10-30-5 15H3.332"
            />
        </g>
        <defs>
            <clipPath id="Activity_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotActivity.displayName = "SpotActivity";
